/* eslint-disable no-undef */
(function() {
	angular.module('meanApp').controller('recipeReadCtrl', recipeReadCtrl);

	recipeReadCtrl.$inject = [
		'$scope',
		'$location',
		'context',
		'$uibModal',
		'recipesManager',
		'measuresManager',
		'Recipe',
		'$state',
		'nutritionService',
		'colors',
		'$sce',
		'$compile',
		'currentUser',
		'tagService'
	]; //used for sanityzing html
	function recipeReadCtrl(
		$scope,
		$location,
		context,
		$uibModal,
		recipesManager,
		measuresManager,
		Recipe,
		$state,
		nutritionService,
		Colors,
		$sce,
		$compile,
		currentUser,
		tagService
	) {
		var vm = this,
			INGREDIENTS_COLORS = [
				'#F49AC2',
				'#CB99C9',
				'#C23B22',
				'#FFD1DC',
				'#DEA5A4',
				'#AEC6CF',
				'#77DD77',
				'#B39EB5',
				'#FFB347',
				'#B19CD9',
				'#FF6961',
				'#03C03C',
				'#FDFD96',
				'#779ECB',
				'#966FD6'
			];
		vm.currentCompletion = 0; //used to display the progress bar
		vm.currentIndex = 0;
		vm.widthProgressBar = {
			width: vm.currentCompletion + '%'
		};
		//vm.areGoodthingsExpanded = false;
		vm.goodThings = [];
		vm.badThings = [];
		vm.recipe = {};
		vm.recipe.interactions = {};


		//for widgetisation integration : 
		vm.widgetPreviewOptions = {
			image: true,
			nutriscore: true,
			goodThings: true,
			badThings: true,
			nutritags: true,
			monthProduction: false
		};

		vm.getCodeToSelect = function() {
			var domain = document.location.origin;
			return vm.recipe._id ? $sce.trustAsHtml(
				`<div class='` +
					vm.getClassesToHide() +
					`' ng-app="meanApp" id="fob-widget" ng-controller="ingredientWidgetCtrl" widget-data='` +
					vm.getWidgetData() +
					`'>Infos nutritionnelles</div><script type="text/javascript" src="` +
					domain +
					`/ing.w1.js"></script>`
			) : 'Veuillez chercher une recette pour générer du code HTML';
		};

		vm.onCopyInClipboard = function() {
			navigator.clipboard.writeText(vm.getCodeToSelect()).then(
				function() {
					vm.copyButtonClicked = true;
				},
				function() {
					//note n°3 : if this fails (like on safari for instance... :( ) may be fallback here on the old execCommand API
				}
			);
		};

		vm.getClassesToHide = function() {
			var classes = '';
			if (vm.widgetPreviewOptions.image === false) {
				classes += 'aa ';
			}
			if (vm.widgetPreviewOptions.nutriscore === false) {
				classes += 'bb ';
			}
			classes += 'cc'; //hide the months by default
			if (vm.widgetPreviewOptions.goodThings === false) {
				classes += 'dd ';
			}
			if (vm.widgetPreviewOptions.badThings === false) {
				classes += 'ee ';
			}
			if (vm.widgetPreviewOptions.nutritags === false) {
				classes += 'ff ';
			}
			//vm.classes= classes;
			return classes;
		};

		vm.getWidgetData = function() {
			var widgetData = {
				_id: vm.recipe._id,
				title: vm.recipe.title,
				price: Math.round(vm.recipe.price * 10) / 10,
				slug: vm.recipe.slug,
				hexDominantColor: vm.recipe.hexDominantColor,
				percentageFruitsAndVegetables: vm.recipe.percentageFruitsAndVegetables,
				nutrientsQuantity:  vm.recipe.nutrientsQuantity ? vm.recipe.nutrientsQuantity.map(function(nutrientQuantity) {
					//return a cleaned and lighter structure for the widget
					return {
						nutrient: {
							_id: nutrientQuantity.nutrient._id,
							unit: nutrientQuantity.nutrient.unit
						},
						quantity: Math.round(nutrientQuantity.quantity * 10) / 10
					};
				}) : [],
				monthsSoldInFrance : vm.recipe.monthsSoldInFrance,
				nutriscoreLetter: vm.recipe.nutriscore,
				tagNames: vm.recipe.tags,
				almostTags : vm.recipe.almostTags
			};
			//here reduce the amount od data passed
			return JSON.stringify(widgetData);
		};

		vm.triggerCodePreview = function() {
			//1- we need to load the ingredient-nutrition widget file
			var domain = document.location.origin;
			vm.loadScript(domain + '/widget/ingredient-nutrition.js', function() {
				var widgetEl = angular.element(document.getElementById('fob-widget'));
				$compile(widgetEl.contents())($scope);
			});
		};

		vm.onPreviewChange = function() {
			//vm.getCodeToSelect();
			var widgetEl = angular.element(document.getElementById('fob-widget'));
			$compile(widgetEl.contents())($scope);
		};

		vm.getTagTranslated = function(tag) {
			return tagService.wording[tag];
		};

		vm.typeaheadOnSelect = function(item) {
			//here perform a call to the back end and get more info about this ingredient
			var slugOfRecipe = item.slug;
			console.log('the slug of the recipe is ', slugOfRecipe);
			vm.goodThings = [];
			vm.badThings = [];
			recipesManager.get(slugOfRecipe, false, true).then(
			function(result) {
				vm.recipe = result;
				vm.typedRecipe = vm.recipe.title;

				vm.nutriscoreLetter = vm.recipe.nutriscore;
				vm.recipe.tagNames = vm.recipe.tags;
				var infoGoodAndBad = nutritionService.getGoodAndBadThings(result.nutrientsQuantity);
				vm.goodThings = infoGoodAndBad.goodThings;
				vm.badThings = infoGoodAndBad.badThings;


				//TODO addothergoodthings to be refactored
				vm.addOtherGoodThings(vm.goodThings);
			});
		};

		//TODO to be moved in a utils
		vm.loadScript = function(url, callback) {
			if (url) {
				var script = document.querySelector("script[src*='" + url + "']");
				//if (!script) {
					var heads = document.getElementsByTagName('head');
					if (heads && heads.length) {
						var head = heads[0];
						if (head) {
							script = document.createElement('script');
							script.setAttribute('src', url);
							script.setAttribute('type', 'text/javascript');
							script.onload = function() {
								callback && callback();
							};
							script.onerror = function() {
								callback && callback();
							};
							//if (charset) script.setAttribute('charset', charset);
							head.appendChild(script);
						}
					}
				//}
				return script;
			}
		};

		var updateCompletionAndScroller = function() {
			vm.currentCompletion = 100 * (vm.currentIndex + 1) / vm.recipe.instructions.length;
			vm.widthProgressBar = {
				width: vm.currentCompletion + '%'
			};
			//smoooth
			var element = document.getElementById('step-' + vm.currentIndex),
				elementForOffset = document.querySelector('.next-prev-container'),
				isDesktop =
					document.querySelector('.mobile-nav') && document.querySelector('.mobile-nav').offsetHeight > 0;

			if (isDesktop && elementForOffset) {
				element.scrollIntoView({
					behavior: 'smooth',
					block: elementForOffset.offsetHeight ? 'center' : 'start' //center if desktop
				});
			}
		};

		vm.scrollToInstructions = function() {
			/*var element = document.getElementById('instructions');
            if(element) {
                element.scrollIntoView({
                    behavior: 'smooth'
                });
            }*/
			//scroll is not working properly so for now just go to instructions
			vm.goToInstructions();
		};

		vm.goToInstructions = function() {
			$state.go('recipeInstructions', {
				id: vm.recipe.slug
			});
		};

		vm.goToNextInstruction = function(event) {
			event.stopPropagation();
			if (vm.currentIndex < vm.recipe.instructions.length) {
				vm.currentIndex++;
				updateCompletionAndScroller();
			}
		};

		vm.goToInstruction = function(index) {
			vm.currentIndex = index;
			updateCompletionAndScroller();
		};

		vm.goToPreviousInstruction = function(event) {
			event.stopPropagation();
			if (vm.currentIndex !== 0) {
				vm.currentIndex--;
				updateCompletionAndScroller();
			}
		};

		vm.addOtherGoodThings = function(goodThings) {
			if (vm.recipe.pricePerKilo < 5) {
				goodThings.push({
					name: 'Economique',
					description: 'Ce produit est économique',
					level: 1,
					iconName: 'fob-moneybox'
				});
			}

			if (vm.recipe.tags.indexOf('local') > -1) {
				goodThings.push({
					name: 'Local',
					description: 'Ce produit peut provenir de France métropolitaine',
					level: 1,
					iconName: 'fob-crosshair'
				});
			}

			if (vm.recipe.percentageFruitsAndVegetables > 80) {
				goodThings.push({
					name: 'Fruits & Légumes',
					description: 'Ce produit contient plus de 80% de fruits et légumes',
					level: 1,
					iconName: 'fob-carrot-and-apple'
				});
			}
		};

		//this means we are in the context of widgetisation
		if($state.params.slug) {
			

			recipesManager.get($state.params.slug, false, true).then(
				function(result) {
					vm.recipe = result;
					vm.typedRecipe = vm.recipe.title;

					vm.nutriscoreLetter = vm.recipe.nutriscore;
					vm.recipe.tagNames = vm.recipe.tags;
					var infoGoodAndBad = nutritionService.getGoodAndBadThings(result.nutrientsQuantity);
					vm.goodThings = infoGoodAndBad.goodThings;
					vm.badThings = infoGoodAndBad.badThings;


					//TODO addothergoodthings to be refactored
					vm.addOtherGoodThings(vm.goodThings);
				});
		}

		if ($state.params.id) {
			recipesManager.get($state.params.id, false, true).then(
				function(result) {
					vm.recipe = result;

					// set bad and good things about the recipe
					var infoGoodAndBad = nutritionService.getGoodAndBadThings(result.nutrientsQuantity);
					vm.recipe.goodThings = infoGoodAndBad.goodThings;
					vm.recipe.badThings = infoGoodAndBad.badThings;
					vm.recipe.hexDominantColorAlpha = Colors.hexToHSLLighter(vm.recipe.hexDominantColor, 70);
					//vm.recipe.hexDominantColor = Colors.getClosestColorPossible(vm.recipe.hexDominantColor);
					//ar indexOfInsertion = vm.recipe.hexDominantColor.indexOf(')') -1;
					//vm.recipe.linearStyle = "{background: 'linear-gradient(to left top, "+vm.recipe.hexDominantColorAlpha+" 30%, "+ vm.recipe.hexDominantColor+" 100%)'}";
					vm.recipe.linearStyle =
						'linear-gradient(to right top, ' +
						vm.recipe.hexDominantColor +
						' 40%, ' +
						vm.recipe.hexDominantColorAlpha +
						' 100%)';
					console.log('the linear style is', vm.recipe.linearStyle);
					vm.addOtherGoodThings(vm.recipe.goodThings);

					vm.currentCompletion = 100 * 1 / vm.recipe.instructions.length;
					vm.widthProgressBar = {
						width: vm.currentCompletion + '%'
					};

					//If there is a current user and the current user is the author of the recipe, then
					//the edit button must be put in the context bar

					var contextParams = {
						title : this._getTitle(result.title), 
						contextName: result.title,
						colorBackground: result.hexDominantColor,
						dropDownActions : [{
							iconName: 'widget',
							actionTitle : 'Widget',
							dropdownActionCallback: function() {
								vm.goToWidgetisation();
							}
						}]
					};

					currentUser.get().then(function(userModel) {
						if (userModel._id === vm.recipe.author._id) {
							vm.displayEditButton = true;
							/*contextParams.iconCallback = function() {
								vm.goToEditRecipe(vm.recipe);
							};
							contextParams.iconAction = 'pencil';*/
							contextParams.dropDownActions.push({
								iconName : 'pencil',
								actionTitle : 'Modifier',
								dropdownActionCallback: function() {
									vm.goToEditRecipe(vm.recipe);
								}
							});
						}
						context.set(contextParams);
					});

					vm.recipe.getInteractions().then(
						function(data) {
							vm.recipe.interactions = data;
							console.log('the api interactions on ingredient succeeded', data);
						},
						function() {
							console.log('the api like on ingredient failed');
						}
					);

					//do this special treatment only when in the zen mode for instructions otherwise this fucks up the DATA
					if ($state.current.name === 'recipeInstructions') {
						vm.recipe.instructionsHaveMarkup = true;
						vm.performArtificialIntelligenceOnInstructions();
					}
				}.bind(this),
				function(err) {
					console.log('error loading the ingredient', err);
				}
			);
		}
		else {
			context.set({
				title : "Widget de recette avec ses infos nutritionnelles",
				contextName : 'Widget'
			});
		}

		this._getTitle = (title) => {
			let ansTitle = title+", sa recette et ses infos nutritionnelles";
			if ($state.current.name === 'recipeInstructions') {
				ansTitle = "Préparation facile de la recette "+ title;
			}

			return ansTitle;
		};


		vm.performArtificialIntelligenceOnInstructions = function() {
			//first go into every instruction and change the dom to highlight keywords
			var ingredientsQuantity = vm.recipe.ingredientsQuantity.concat(vm.recipe.unknownIngredientsQuantity),
				ingredientName,
				splittedIngredient = [],
				wordsBlackList = [ 'de', 'la', 'les', 'le', 'et', 'en' ];
			//splitting by empty space ? what about '-' ?
			//cool test
			ingredientsQuantity.forEach(function(ingredientQuantity) {
				ingredientName = ingredientQuantity.ingredient.name || ingredientQuantity.ingredient; // can be known or unknown ingredients
				if (ingredientName) {
					//replace the words into parenthesis
					ingredientName = ingredientName.replace('(', '').replace(')', '');
					splittedIngredient = ingredientName.split(' ');
					//remove common words
					splittedIngredient = splittedIngredient.filter(function(splittedIngWord) {
						return wordsBlackList.indexOf(splittedIngWord) === -1;
					});

					splittedIngredient.forEach(function(splittedIngredientWord) {
						vm.recipe.instructions.forEach(function(instruction, index) {
							//if the word is found then
							//add the wrapping around ALL words with regexp
							instruction.instruction = instruction.instruction.replace(
								new RegExp(splittedIngredientWord, 'gi'),
								function(match) {
									//push the index of the step on the ingredient
									if (!ingredientQuantity.stepRelated) {
										ingredientQuantity.stepRelated = [ index ];
									} else if (ingredientQuantity.stepRelated.indexOf(index) === -1) {
										//if not already into array, push it
										ingredientQuantity.stepRelated.push(index);
									}
									return '<span class="highlighted-ingredient">' + match + '</span>';
								}
							);
						});
					});
				}
			});

			//sanytize the values now
			vm.recipe.instructions.forEach(function(instruction) {
				instruction.instruction = $sce.trustAsHtml(instruction.instruction);
			});
		};

		vm.goToEditRecipe = function(recipe) {
			$state.go('recipecreationstep', {
				id: recipe.slug,
				step: '1'
			});
		};

		vm.goToWidgetisation = function() {
			$state.go('recipeWidget', {
				slug: vm.recipe.slug
			});
		};

		vm.goToAuthorPage = function() {
			$state.go('profile.info', {
				id: vm.recipe.author._id
			});
		};

		vm.loadMeasures = function() {
			measuresManager.getAll().then(
				function(measures) {
					console.log('measures are ', measures);
					vm.measures = measures.collection;
				},
				function(err) {
					console.log('error loading all measures', err);
				}
			);
		};

		vm.getColor = function(ingredientName) {
			var nbColors = INGREDIENTS_COLORS.length,
				toBeReturned = INGREDIENTS_COLORS[0],
				firstLetter = parseInt(ingredientName.charAt(0), 36) - 9;
			if (ingredientName.length > 1) {
				var secondLetter = parseInt(ingredientName.charAt(1), 36) - 9,
					average = (firstLetter + secondLetter) / 2,
					ratio = average / 26; //26 is the number of letters in occidental alphabet
				toBeReturned = INGREDIENTS_COLORS[Math.trunc(ratio * nbColors)];
			} else {
				toBeReturned = INGREDIENTS_COLORS[Math.trunc(firstLetter / 26 * nbColors)];
			}
			console.log(toBeReturned);
			return toBeReturned;
		};

		vm.onLikeRecipe = function() {
			if (vm.recipe.interactions.isLiked) {
				vm.recipe.unlike();
				vm.recipe.interactions.likeCount--;
			} else {
				vm.recipe.like();
				vm.recipe.interactions.likeCount++;
			}

			//increase counter as well
			vm.recipe.interactions.isLiked = !vm.recipe.interactions.isLiked;
		};

		vm.onBookmarkRecipe = function() {
			if (vm.recipe.interactions.isBookmarked) {
				vm.recipe.unbookmark();
				vm.recipe.interactions.bookmarkCount--;
			} else {
				vm.recipe.bookmark();
				vm.recipe.interactions.bookmarkCount++;
			}
			vm.recipe.interactions.isBookmarked = !vm.recipe.interactions.isBookmarked;
		};

		vm.absoluteRef = function(id) {
			return 'url(' + $location.absUrl() + '#' + id + ')';
        };
        
        vm.recipesSearchResult = function(recipeTitle) {
			//here return a promise
			return recipesManager.searchRecipes([recipeTitle], 1).then(
				function(results) {
                    //eventual special treatment
					return results.docs;
				},
				function(err) {
					console.log('err', err);
				}
			);
		};

		vm.onExportFirst = function(id) {
			html2canvas(document.getElementById(id), {allowTaint : true}).then(function(canvas) {
				var link = document.createElement("a");
				document.body.appendChild(link);
				link.download = vm.recipe.title+'_'+id;
				link.href = canvas.toDataURL("image/png");
				link.target = '_blank';
				link.click();
			});
		};
	}
})();
